import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lp2-live-class-state-view-title',
  template: `
    <div class="d-flex flex-row flex-wrap align-items-center justify-content-between">
      <span class="divider mr-sm-3"></span>
      <span id="labelKey" class="fw-bold fs-6 lh-4 ml-auto mr-auto mt-xl-0 mt-2">{{ labelKey | translate }}</span>
      <ng-content></ng-content>
      <span class="divider ml-3 d-none d-sm-block"></span>
    </div>
  `,
  styleUrls: ['./live-class-state-view-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveClassStateViewTitleComponent {
  @Input() labelKey: string;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/live-class-state-view-title/live-class-state-view-title.component.ts